export default "__VITE_ASSET__C3vyj$OD__"